import { useParams } from "react-router-dom";
import Header from "../components/Header";
import { t } from "../app/Translate";
import Footer from "../components/Footer";
import FormContact from "../components/FormContact";

const Register = () => {     
    const {isocode}: any = useParams();   
    return(
        <>
            <Header isocode={isocode} active=""/>
            <main className="main-content">                        
                <section className="header-plans" style={{paddingTop:"20px"}}>                    
                </section>        
                <FormContact isocode={isocode}/>                       
                <Footer isocode={isocode} />  
            </main>
        </>
    )
}

export default Register;